<template>
  <div class="modal-card has-text-centered" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("bags.attention") }}
      </p>
    </header>

    <section class="modal-card-body">
      <p>
        {{ $t("bags.bagDeletionNote1") }} ({{ bag.name }})
        {{ $t("bags.bagDeletionNote2") }}
        <br />
        {{ $t("bags.toContinueInsertPassword") }}
      </p>
      <br />

      <b-input
        v-model="password"
        type="password"
        :placeholder="$t('bags.yourPassword')"
        password-reveal
        style="max-width: 400px; margin: auto;"
      ></b-input>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button class="button is-danger" type="button" @click="deleteBag">
        {{ $t("common.delete") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../mixins/common";

export default {
  props: ["storeId", "bag"],

  mixins: [common],

  data() {
    return {
      isLoading: false,
      password: ""
    };
  },

  methods: {
    deleteBag() {
      this.isLoading = true;
      this.$store
        .dispatch("deleteBag", {
          storeId: this.storeId,
          bagId: this.bag._id,
          password: this.password
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: this.$t("bags.bagDeleted"),
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
            this.$emit("on-bag-deleted", this.bag);
            this.$parent.close();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
